module.exports = __webpack_public_path__ + "img/img2.491a6170.jpg";